import { render, staticRenderFns } from "./showModel.vue?vue&type=template&id=093a36dc&scoped=true&"
import script from "./showModel.vue?vue&type=script&lang=js&"
export * from "./showModel.vue?vue&type=script&lang=js&"
import style0 from "./showModel.vue?vue&type=style&index=0&id=093a36dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093a36dc",
  null
  
)

export default component.exports